export default __webpack_public_path__ + "static/media/copyright_white.c99dbed9.svg";